import { Component, Input, OnChanges, ViewEncapsulation } from '@angular/core';
import { documentToHtmlString, Options } from '@contentful/rich-text-html-renderer';
import { Document, INLINES } from '@contentful/rich-text-types';

@Component({
  selector: 'kui-rich-text',
  templateUrl: './rich-text.component.html',
  styleUrls: ['./rich-text.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class RichTextComponent implements OnChanges {
  @Input() richText: Document;
  @Input() options?: Partial<Options>;
  @Input() onBackground = false;
  @Input() targetExternalLinks = false;

  html: string;

  ngOnChanges() {
    this._renderTemplate();
  }

  private _renderTemplate() {
    if (this.richText) {
      if (!this.options && this.targetExternalLinks) {
        this.options = {
          renderNode: {
            [INLINES.HYPERLINK]: (node, next) => {
              const addTargetBlank = /^https?:\/\//.test(node.data.uri) ? ' target="_blank"' : '';
              return `<a href="${node.data.uri}"${addTargetBlank}>${next(node.content)}</a>`;
            },
          },
        };
      }
      this.html = documentToHtmlString(this.richText, this.options);
    }
  }
}
